var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSaveSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSaveSearch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discover---Saved-Search-Reset",
    transform: "translate(-193.000000, -717.000000)",
    fill: "#AAAAAA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left",
    transform: "translate(119.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(14.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(60.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bookmark",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.705054,0 L0.507137333,0 C0.234567901,0 0.0133101728,0.22106479 0.0133101728,0.49382716 L0.0133101728,18.9890046 C0.0129243951,19.3595679 0.219907407,19.6990741 0.549382716,19.8684414 C0.879050914,20.0376158 1.27565585,20.0081018 1.57638889,19.7918596 L7.1060957,15.8279321 L12.6359954,19.7916667 C12.9369213,20.0075232 13.3331404,20.0368441 13.6626158,19.8676697 C13.9918982,19.6984954 14.1990741,19.3591821 14.1990741,18.9890046 L14.1990741,0.49382716 C14.1990741,0.22106479 13.9778163,0 13.705054,0 Z M13.2112269,18.9888118 L7.39409723,14.8188657 C7.22202933,14.6956019 6.99054785,14.6956019 6.81867284,14.8188657 L1.00135032,18.9890046 L1.00135032,0.987654321 L13.2112269,0.987654321 L13.2112269,18.9888118 Z",
    id: "icSaveSearch"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSaveSearch);
export default __webpack_public_path__ + "static/media/icSaveSearch.25edd97a6267d81dc054a9b8c8cce398.svg";
export { ForwardRef as ReactComponent };